export default __webpack_public_path__ + "static/media/smart-folder-open-paret-small.77071688.svg";